module.exports = __webpack_public_path__ + "static/media/img12.ff7a2608.JPG";